import React, { useContext, useEffect, useState } from 'react';
import ImageMapper from 'react-img-mapper';
import styled from '@emotion/styled';
import _ from 'lodash';
import {
  createIrollKeyEvent,
  toggleIrollMute,
} from '../player/CtvIroll';
import remote from '../../../../images/remote/Remote.png';
import remoteNonBranded from '../../../../images/remote/RemoteNoBrand.png';
import {
  Back,
  Down,
  Left,
  Mute,
  Ok,
  Play,
  Right,
  Up,
} from './InteractiveRemoteIcon';
import useSize from '@react-hook/size'
import { DemoContext } from '../../Demo';

interface KeyData{
  coords:number[];
  onClick:any;
  shape:'poly'|'circle'|'rect';
  hoverImage?:  any;
  clickImage?:  any;
  keyCode?:number
}


const keysData:{[key:string]:KeyData} = {
  play:{
    coords: [240,443,241,481,180,481,165,462,180,439],
    onClick: ()=> dispatchKeyEvent('play',32),
    shape:'poly',
    hoverImage:  <Play opacity={1}/>,
    clickImage:  <Play opacity={0.4}/>,
  },
  back:{
    coords:[270,130,229,131,214,141,211,170,240,170,289,171,287,139,270,129],
    onClick: ()=> dispatchKeyEvent('back',8),
    shape:'poly',
    hoverImage:  <Back opacity={1}/>,
    clickImage:  <Back opacity={0.4}/>,
  },
  down:{
    coords:[214,340,230,348,259,353,286,337,318,370,285,395,249,400,207,391,179,371],
    onClick: ()=> dispatchKeyEvent('down',40),
    shape:'poly',
    hoverImage:  <Down opacity={0.2}/>,
    clickImage:  <Down opacity={0.1}/>,
  },
  left:{coords:[212,339,180,370,157,336,152,299,164,257,182,233,212,265,199,287,199,314],
    onClick: ()=> dispatchKeyEvent('left',37),
    shape:'poly',
    hoverImage:  <Left opacity={0.2}/>,
    clickImage:  <Left opacity={0.1}/>,
  },
  up:{
    coords:[213,265,237,254,270,256,286,267,318,236,279,208,220,206,180,234],
    onClick: ()=> dispatchKeyEvent('up',38),
    shape:'poly',
    hoverImage:  <Up opacity={0.2}/>,
    clickImage:  <Up opacity={0.1}/>,

  },
  right:{
    coords:[287,268,319,236,335,260,342,283,346,311,341,338,326,361,319,369,289,339,302,301],
    onClick: ()=> dispatchKeyEvent('right',39),
    shape:'poly',
    hoverImage:  <Right opacity={0.2}/>,
    clickImage:  <Right opacity={0.1}/>,
  },
  ok:{
    coords:[248,303,53],
    onClick: ()=> dispatchKeyEvent('ok',13),
    shape:'circle',
    hoverImage:  <Ok opacity={1}/>,
    clickImage:  <Ok opacity={0.4}/>,
  },
  mute:{
    coords:[256,440,319,440,329,450,332,460,329,472,317,481,257,482],
    onClick: ()=> toggleIrollMute(),
    shape:'poly',
    hoverImage:  <Mute opacity={1}/>,
    clickImage:  <Mute opacity={0.4}/>,
  },

};

const dispatchKeyEvent = (keyName:string,keyCode:number)=>{
  document.dispatchEvent(createIrollKeyEvent({type:'keydown',key: keyName, keyCode}));
  //@ts-ignore
  document.dispatchEvent(createIrollKeyEvent({type:'keyup',key: keyName, keyCode}));
};

const getRemoteMap = () => {
  let areas: any[] = [];
  for (let key in keysData) {
    if(!!keysData[key]){
      const keyArea = {
        name: key,
        coords: keysData[key].coords,
        shape: keysData[key].shape,
      };
      areas.push(keyArea);
    }
  }
  return {
    name: 'remote-map',
    areas
  };
};

export const InteractiveRemote = () => {
  const [indicatorImage, setIndicatorImage] = useState(null);
  const target = React.useRef(null)
  const height = useSize(target)[1];
  const {isExternal} = useContext(DemoContext);
  const remoteImage = isExternal ? remoteNonBranded : remote;

  const map = getRemoteMap();

  const onClick = (area) => {
    keysData[area.name].onClick();
    setIndicatorImage(keysData[area.name].clickImage);
    setTimeout(() => setIndicatorImage(keysData[area.name].hoverImage), 150);
  };

  const onMouseEnter = (area) => {
    setIndicatorImage(keysData[area.name].hoverImage);
  };

  const onImageMouseMove = () => setIndicatorImage(null);

  useEffect(()=>{
    document.addEventListener('keydown', (e)=>{
      const keyData =_.find(keysData,key=> {
        return key.keyCode === e.keyCode;
      });
      !!keyData && setIndicatorImage(keyData.clickImage);
    });

    document.addEventListener('keyup', ()=>{

      setIndicatorImage(null);
    });

  },[]);

  return <InteractiveRemoteImgContainer ref={target}>
    <ImageMapper src={remoteImage} map={map} width={height*0.54} imgWidth={498}
                 onClick={onClick} onMouseEnter={onMouseEnter} active={false}
                 onImageMouseMove={onImageMouseMove}
    />
    {indicatorImage}
  </InteractiveRemoteImgContainer>;
};

const InteractiveRemoteImgContainer = styled.div`
  position: relative;
  left: -25%;
  max-height: 82%;
 `;
